export default "__VITE_ASSET__C6C6Zceb__"